// Required JS from local files
import { posthogPageviewEvent } from '~/utils/posthog/general';
import {
   posthogRegistrationAccountTypeChosen,
   posthogRegistrationClassJoinUrlLoaded,
   posthogRegistrationCompleted,
   posthogRegistrationNewSchoolLinkClicked,
   posthogRegistrationSchoolChosen,
   posthogRegistrationSchoolNotFound,
   posthogRegistrationWithoutSchoolChosen
} from '~/utils/posthog/registration';
import {
   addInitialFunction,
   dfmAlert,
   parseJwtPayload,
   validateEmail,
} from './dfm5';

// CSS
import './register-new.css';

/**
 * Configure and render Google SSO button
 * https://developers.google.com/identity/gsi/web/guides/display-button#javascript
 */
window.onload = function () {
   if (window.google) {
      google.accounts.id.initialize({
         client_id: window.DFL?.googleClientId || "NO-GOOGLE-CLIENT-ID-AVAILABLE",
         callback: handleGoogleSignIn
      });
      google.accounts.id.renderButton(
         document.getElementById("register-button-google"),
         { theme: "outline", size: "large" }
      );
   }
}

$(document).ready(function(){
   // Send a page view event when Context is available.
   addInitialFunction(posthogPageviewEvent);

   // Also send a page view event if we've navigated here via the bfcache
   window.addEventListener('pageshow', (event) => {
      if (event.persisted) {
         posthogPageviewEvent();
      }
   });

   $("input[name=school]").dfmSchoolSelector({ callback: function(school) {
      selectSchool(school);

      // PostHog event for school selection.
      const results = $(".dfmSchoolSelector_results a").get().map(a => a.id) ?? [];
      const selectedIndex = results.findIndex(link => link.includes(school.sid));
      const accountType = $("input[name=account-type]").val();
      if (selectedIndex !== -1) {
         posthogRegistrationSchoolChosen({
            triggerId: "register-school-selector",
            school,
            search: {
               query: $("input[name=school]").val(),
               results: results.length,
               position: selectedIndex + 1,
            },
            accountType,
         });
      }
   }});

   $("#regform-type-student").click(function(){ selectAccountType("student", true) });
   $("#regform-type-teacher").click(function(){ selectAccountType("teacher", true) });
   $("#regform-type-parent").click(function(){ selectAccountType("parent", true) });
   $("#regform-start-login button").click(function(){ window.location = '/login.php'; return false; });
   $("#regform-cantfindschoollink a").on("click", function(){
      dfmAlert("Before proceeding to request creation of a new school, please check:"
         +"<ol><li>You have tried searching for the postcode/zipcode of your school.</li>"
         +"<li>You have spelled the name of your school correctly.</li>"
         +"</ol><strong>All schools in England and Wales should already be in our list of schools.</strong><br><br>&rarr; <a id='register-new-school-form-link' href='/add-school-request.php'>Fill in our request form for a new school.</a>");

      // PostHog events for school not found.
      const accountType = $("input[name=account-type]").val();
      posthogRegistrationSchoolNotFound({
         triggerId: "register-cannot-find-school-link",
         search: {
            query: $("input[name=school]").val(),
         },
         accountType,
      });
      $("#register-new-school-form-link").on("click", function() {
         const accountType = $("input[name=account-type]").val();
         posthogRegistrationNewSchoolLinkClicked({
            triggerId: "register-new-school-form-link",
            accountType,
         });
      });
   });

   $("#regform-noschoollink a").on("click", function(){
      $("#regform-school").slideUp();
      $("#regform-sso").slideUp();
      $("#regform-final").show();
      $("#regform-row-school").hide();

      // PostHog event for continuing without a school.
      const accountType = $("input[name=account-type]").val();
      posthogRegistrationWithoutSchoolChosen({
         triggerId: "register-without-school-link",
         accountType,
      });
   });

   $("#office365-login").click(function(){
      let type = $("input[name=account-type]").val();
      let url = "azureconnect.php?action=register&account_type=" + type;

      if (preReg.class) {
         url += `&cid=${preReg.class.id}&passcode=${preReg.class.passcode}`;
      }

      window.location = url;
   });

   getRegKey();


   $("#regform-submitrow input[type=submit]").click(function(){

      // Disable the submit button
      $("#regform-submitrow input[type=submit]").prop("disabled", true);

      const formErrors = [];

      var email = $("#regform input[name=email]").val();
      var type = $("#regform input[name=account-type]").val().toLowerCase();

      if ($("#regform input[name=firstname]").val()=="") {
         formErrors.push("No first name was provided.");
      }

      if ($("#regform input[name=surname]").val()=="") {
         formErrors.push("No surname was provided.");
      }

      if (!email) {
         formErrors.push("You must provide an email address.");
      } else if (!validateEmail(email)) {
         formErrors.push("The email address you provide doesn't look right.");
      }

      if (type === "teacher" && (email.indexOf("@hotmail")>=0 || email.indexOf("@live.")>=0 || email.indexOf("@gmail.")>=0 || email.indexOf("@outlook.")>=0 || email.indexOf("@yahoo.")>=0 || email.indexOf("@btinternet.")>=0 || email.indexOf("@mac.com")>=0 || email.indexOf("@aol.")>=0 || email.indexOf("@mailinator.")>=0)) {
         formErrors.push("We strictly only accept teacher email addresses for teacher accounts.");
      }

      if ((type === "teacher" || type === "trust") && $("#regform select[name=newsletter]").val()=="") {
         formErrors.push("Please specify whether you are happy to receive a monthly newsletter via email.");
      }

      if (!$("input[name=googlesso-token]").val() && !$("input[name=firefly-uid]").val() && !$("input[name=office365-uid]").val()) {
         if ($("#regform input[name=password]").val()!=$("#regform input[name=confirmpassword]").val()) {
            formErrors.push("The passwords do not match.");
         } else if ($("#regform input[name=password]").val()=="") {
            formErrors.push("No password was provided.");
         }
      }

      if (!$("#regform input[name=" + DFL.challengeTokenInputId + "]").val()) {
         formErrors.push("Please verify that you're human.");
      }

      if (!preReg.class && type === "student" && !$("#parental-consent").is(':checked')) {
         formErrors.push("Please check that you have parental consent to register and click the checkbox when you have done so.");
      }

      // Report any issues
      if (formErrors.length) {
        dfmAlert(`
          <p>There ${formErrors.length === 1 ? 'is an issue' : 'are some issues'} with the information you’ve provided:</p>
          <ul>${formErrors.reduce((acc, curr) => acc + `<li>${curr}</li>`, '')}</ul>
        `);
        // Re-enable the submit button
        $("#regform-submitrow input[type=submit]").prop("disabled", false);
        return false;
      }

      // Submit the data
      submitCompletedRegistration();
   });

   // Always pass these through if we've got them (and track the appropriate event)
   if (preReg.class) {
      $("input[name=cid]").val(preReg.class.id);
      $("input[name=passcode]").val(preReg.class.passcode);

      posthogRegistrationClassJoinUrlLoaded({
         triggerId: "register-direct-class-join-url",
         classId: Number(preReg.class.id),
         className: preReg.class.name,
      });
   }

   // Returning from SSO login.
   if(preReg.mode) {
      selectAccountType(preReg.accounttype);

      $("#regform-start").hide();
      $("#regform-sso").hide();

      if(preReg.school) {
         $("#regform-school").hide();
         $("#regform-final").show();
         $("#regform-row-school span").html(preReg.school.name);
         $("#regform-row-school input").val(preReg.school.id);
      } else if (preReg.mode === "office365" && preReg.accounttype === "student") {
         $("#regform-school h2").html("Search for your school");
         dfmAlert("We couldn't work out your school from your Microsoft365 account, so you'll need to select this yourself.");
      } else if (preReg.mode === "office365" && preReg.accounttype === "teacher") {
         $("#regform-school h2").html("Search for your school");
         dfmAlert("We couldn't work out your school from your Microsoft365 account, so you'll need to select this yourself.<br><br><strong>Only teacher registrations that use school email addresses will be approved.</strong>");
      }

      if (preReg.accounttype !== "student") {
         $("#regform-consentrow").hide();
      }

      if (preReg.mode === "office365") {
         $("input[name=office365-uid]").val(preReg.username);
      }

      $("input[name=email]").val(preReg.email).prop('readonly', true);
      $("#regform-row-email").hide();
      var firstSpace = preReg.name.indexOf(" ");
      var firstname = preReg.name.substr(0, firstSpace);
      var surname = preReg.name.substr(firstSpace+1);
      $("input[name=firstname]").val(firstname);
      $("input[name=surname]").val(surname);
      $("#regform-row-password").hide();
      $("#regform-row-passwordconfirm").hide();

      $("#regform-final h2").html(`Please confirm your details for ${preReg.email}`);
   }

   // Enrolment for a specific class (and NOT returning from SSO auth)
   else if(preReg.class) {
      $("#regform-consentrow").hide();
      selectAccountType(preReg.accounttype);
      $("#regform-start").hide();
      $("#regform-school").hide();
      $("#regform-final").show();
      $("#regform-row-school span").html(preReg.school.name);
      $("#regform-row-school input").val(preReg.school.id);
      $("#regform-classinfo").show();
      $("#regform-classinfo h2").html(`You are registering to join <strong>${preReg.class.name}</strong> at <strong>${preReg.school.name}</strong>`);
      const escapedClassJoinUrl = encodeURIComponent(`/process-addexistingusertoclass.php?cid=${preReg.class.id}&passcode=${preReg.class.passcode}`);
      $("#regform-classinfo div").html(`<p>If you already have a Dr Frost account, please <a href="/login.php?url=${escapedClassJoinUrl}">log in to join this class</a>.</p><p>If you don't have an account, you can create one using the form below.</p>`);
      if(preReg.school.thumb)$("#regform-classinfo h2").prepend("<img src=\""+preReg.school.thumb+"\">");
      $("#regform-sso h2").html("Do you have a school account with one of these providers?");
      $("#regform-final h2").html("If not, you'll need to fill in this form.");
      if(preReg.yeargroup)$("input[name=yeargroup]").val(preReg.yeargroup);
   }

   else if(preReg.accounttype) {
      setTimeout(function(){
         $("#regform-type-"+preReg.accounttype).effect("bounce", {}, "slow");
      }, 1000);
   }
});


function getRegKey() {
   $.ajax({
      url: "/api/auth/getregkey",
      context: document.body,
      dataType: "json",
      success: function(data){
         $("input[name=regKey]").val(data.key);
      },
      error: function(j) {
         dfmAlert("An error occurred when trying to get a registration key: <strong>"+j.responseText+"</strong>");
      }

   });

}

// Assumes the data has already been validated.
function submitCompletedRegistration() {
   var data = {};
   console.log("SID: "+$('input[name=sid]').val());
   if($('input[name=sid]').val())data.sid = Number($('input[name=sid]').val());
   if($('select[name=title]').val())data.title = $('select[name=title]').val();
   data.firstname = $('input[name=firstname]').val();
   data.surname = $('input[name=surname]').val();
   data.email = $('input[name=email]').val();
   data.newsletter = $('select[name=newsletter]').val() ? Number($('select[name=newsletter]').val()) : 0;
   data.password = $('input[name=password]').val();
   var accountType = $("input[name=account-type]").val();
   data.type = accountType;
   var googleSSO = $("input[name=googlesso-token]").val();
   var fireflySSO = $("input[name=firefly-uid]").val();
   var office365SSO = $("input[name=office365-uid]").val();
   if(googleSSO)data['googlesso_token'] = googleSSO;
   if(fireflySSO)data['firefly_username'] = fireflySSO;
   if(office365SSO)data['office365_uid'] = office365SSO;
   if($("input[name=cid]").val())data.cid = Number($("input[name=cid]").val());
   if($("input[name=passcode]").val())data.passcode = $("input[name=passcode]").val();
   data.challengeToken = $("input[name='" + DFL.challengeTokenInputId + "']").val();

   console.log("[RegDataToSubmit] "+JSON.stringify(data));

   $.ajax({
      url: "/api/auth/register",
      type: "POST",
      contentType:false,
      processData: false,
      cache: false,
      data: JSON.stringify(data),
      success: function(user){
         if (user) {
            const method = googleSSO ? "google_sso" : office365SSO ? "microsoft_sso" : "password";
            const schoolName = $("#regform-row-school span").text();
            const school = user.sid && schoolName ? { sid: user.sid, name: schoolName } : undefined;
            posthogRegistrationCompleted({
               triggerId: "register-form-submit",
               method,
               user,
               school,
               newsletter: data.newsletter,
            });
         }

         var usedSSO = googleSSO || fireflySSO || office365SSO;
         $('body').addClass('register-complete');
         $("#regform-sso").slideUp();
         $("#regform-classinfo").slideUp();
         if(accountType=="teacher") {
            $("#regform-final").slideUp();
            $("#regform-complete").show();
            $("#regform-complete").html("<h1>Registration complete</h1><h2>Your registration will be checked by an administrator shortly and you will receive an email once it's been approved.</h2>");
         } else if(!usedSSO) {
            $("#regform-final").slideUp();
            $("#regform-complete").show();
            $("#regform-complete").html("<h1>Registration complete</h1><h2>To activate your new account, click the link in the email you'll receive shortly.</h2>");
         } else {
            // If not a teacher and SSO was used, can go to their dashboard immediately! RegisterController would have logged them on.
            const queryString = preReg.class ? `?joinedClass=${preReg.class.name}` : ''
            window.location = `/dashboard.php${queryString}`;
         }
      },
      error: function(j, textStatus, errorThrown) {
         // Reset the challenge on error
         // TODO: Could look at the turnstile idempotency options to allow on-error retries with the same token
         window.DFL?.actions?.resetChallenge();

         // Re-enable the submit button
         $("#regform-submitrow input[type=submit]").prop("disabled", false);

         // Handle specific error types, with a fallback.
         if (j.status === 429) {
            dfmAlert("It looks like our system is temporarily busy due to high activity from you or your school. Please wait a few moments and try submitting the registration form again.")
         } else if (j.responseJSON?.message === "DUPLICATE_EMAIL") {
            let queryString = '';
            if (preReg.class) {
              queryString = `?url=${encodeURIComponent(`/process-addexistingusertoclass.php?cid=${preReg.class.id}&passcode=${preReg.class.passcode}`)}`;
            }
            dfmAlert(`A user already exists with that email address. You might want to <a href="/login.php${queryString}">log in</a> or <a href='/reset-password.php'>reset your password</a>.`);
         } else if (j.responseJSON?.message === "REGISTER_REQUIRE_SUBSCRIPTION") {
            dfmAlert("<p>We require schools to subscribe with us in order to have more than 1 teacher account.</p><p>Please ask the registered teacher at your school to go to the Subscription page, found under Classes & Settings.</p><p>If you have any further questions, please contact us at <a href='mailto:support@drfrost.org'>support@drfrost.org</a>.</p>");
         } else {
            let msg = "An error occurred when trying to register";
            msg += j.responseText ? `: <strong>${j.responseText}</strong>` : ".";
            dfmAlert(msg);
         }
      }
   });

}

function selectSchool(school) {
   // Ticket 346 - check whether the school requires SSO for this account type - and if so, send the user back to the SSO section
   if (school.ssorequired === "ALL" || school.ssorequired === "TEACHERS" && $("input[name=account-type]").val() === "teacher") {
      $("#regform-school").slideUp();
      $("#sso-required").show();
   }
   else {
      $("#regform-school").slideUp();
      $("#regform-sso").slideUp();
      $("#regform-final").show();
      $("#regform-row-school span").html(school.name);
      $("#regform-row-school input").val(school.sid);
   }
}

function useGoogleUser(payload, token) {
   $("#firstname").val(payload['given_name']);
   $("#surname").val(payload['family_name']);
   $("#email").val(payload['email']).prop('readonly', true);
   $("#regform-row-password").hide();
   $("#regform-row-passwordconfirm").hide();
   $("input[name=googlesso-token]").val(token);
}



function selectAccountType(type, posthogEvent = false) {
   $("input[name=account-type]").val(type);
   $("#regform-start").slideUp();
   $("#regform-sso h2").html("Sign up as a "+type+" with...");
   $("#regform-sso").show();
   if(type=="student") {
      $("#regform-school").show();
      $("#personal-msg2").show();
      $("#regform-row-title").hide();
      $("#regform-row-newsletter").hide();
      $("#regform-consentrow").show();
   } else if(type=="teacher") {
      $("#regform-school").show();
      $("#regform-noschoollink").hide(); // teachers must select a school
      $("#personal-msg").show();
      $("#regform-consentrow").hide();
   } else if(type=="parent") {
      $("#regform-final").show();
      $("#regform-row-school").hide();
      $("#email-label").html("Email:");
      $("#regform-row-title").hide();
      $("#regform-row-newsletter").hide();
      $("#regform-consentrow").hide();
      $("#regform-final h2").html("or provide some info...");
   }

   if (posthogEvent && ["student", "teacher", "parent"].includes(type)) {
      posthogRegistrationAccountTypeChosen({
         triggerId: "register-account-type-buttons",
         accountType: type,
      });
   }
}

function handleGoogleSignIn(response) {
   const token = response.credential;
   console.log("ID Token: " + token);

   const payload = parseJwtPayload(token);

   // Set up the school-search header appropriately
   if ($("input[name=account-type]").val() === "teacher") {
      $("#regform-school h2").html("Search for your school.");
   } else {
      $("#regform-school h2").html("Search for your school, or continue without a school.");
   }

   if(payload['hd'] && $("input[name=account-type]").val() !== "parent") { // check for hosted domain, unless it's a parent account
      var url = "/util-getschoolfromdomain.php?domain="+payload['hd']+"&email="+payload['email'];
      console.log(url);
      $.ajax({
         url: url,
         context: document.body,
         dataType: "json",
         success: function(data, textStatus, jqXHR){
            if(data.error == "ALREADYLINKED") {
               let queryString = '';
               if (preReg.class) {
                  queryString = `?url=${encodeURIComponent(`/process-addexistingusertoclass.php?cid=${preReg.class.id}&passcode=${preReg.class.passcode}`)}`;
               }
               dfmAlert(`<p>That Google account is already linked to a Dr Frost account.</p><p><a href="/login.php${queryString}">Click here to log in</a></p>`);
            } else {
               // Use the information returned by Google.
               useGoogleUser(payload, token);

               // There could already be a school selected, if joining via a class link.
               const schoolAlreadySelected = !!$("input[name=sid]").val();

               // If there isn't a school already selected, try to set the school matched from the domain.
               if (!schoolAlreadySelected) {
                  if (data.sid) {
                     selectSchool(data);
                  } else {
                     dfmAlert("We tried to automatically determine your school, but the domain <strong>"+payload['hd']+"</strong> doesn't seem to match with any of the schools in our database. If you want us to change this, please contact <a href='mailto:support@drfrost.org'>support@drfrost.org</a>.<br><br>Please manually select your school.");
                  }
               } else {
                  $("#regform-sso").slideUp();
               }

               $("#regform-row-email").hide();
               $("#regform-final h2").html(`Please confirm your details for ${payload['email']}`);
            }
         }
      });

   } else {
      useGoogleUser(payload, token);
      $("#regform-final h2").html(`Please confirm your details for ${payload['email']}`);
      $("#regform-row-email").hide();
      $("#regform-sso").slideUp();
   }
}

function searchFireflySchools() {
   $.ajax({
      url: "/util-schoolsearch.php?firefly=1&school="+$("input[name=firefly-school]").val(),
      context: document.body,
      dataType: "json",
      success: function(data, textStatus, jqXHR){
         console.log(data.length+" results");
         $("#fireflyschool-results").html("");
         $.each(data, function(k,s) {
            $("#fireflyschool-results").append("<li><a href='#' id='fireflyschool-"+s.id+"'><h1>"+(s.thumb ? "<img style='float:left;margin-right:10px;border-radius:5px' src='"+s.thumb+"'>" : "")+s.name+"</h1><h2>"+s.town+"</h2></a></li>");
            $("#fireflyschool-"+s.id).click(function(){
               window.location = "https://"+s.firefly+"/login/api/webgettoken?app=drfrostmaths&successURL="+encodeURIComponent(window.location.origin + "/auth.php?mode=firefly&action=register&domain="+s.firefly+"&accounttype="+$("#register-form input[name=account-type]").val())+"&failURL=" + window.location.origin + "/error.php";
            });
         });
      }
   });
}
